export default {
  name: 'AwebSocket',
  props: {
    ip: { type: String, default: () => '127.0.0.1:8000' },
    type: { type: String, default: () => 'ws' },
    ping: { type: String, default: () => 'ping' },
    headers: { type: Object, default: () => ({}) },
    delay: { type: Number, default: () => 3000 },
    enable: { type: Boolean, default: () => true },
    prompt: { type: Boolean, default: () => true },
    timeout: { type: Number, default: () => 60000 * 5 },
  },
  data() {
    return {
      host: this.ip.includes('://') ? this.ip : (`${this.type}://${this.ip}`),
      status: this.enable,
      session: null,
      interval: null,
    }
  },
  created() {
    this.create();
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      if (this.status) {
        this.session = new WebSocket(this.host, [], { headers: this.headers });
        this.session.onopen = a => this.opened(a);
        this.session.onmessage = (a) => this.search(a);
        this.session.onerror = a => this.failed(a);
        this.session.onclose = a => this.closed(a);
      }
    },
    opened(a) {
      // this.interval = setInterval(() => this.session.send(this.ping), this.delay); // 心跳检测WS
      this.$emit('open', a);
    },
    search({ data = '' }) {
      if (data != '') {
        let info = JSON.parse(data);
        this.prompt && (this.$notify.info({
          title: '新消息提示',
          message: `收到来自${info.sendName}的消息.`,
          position: 'bottom-right',
          onClick: () => {
            this.$emit('click', info);
            this.$emit('select', info);
          },
        }));
        this.$emit('message', info);
      }
    },
    failed(a) {
      console.log('failed: websocket connect is error.');
      this.$emit('error', a);
      this.$nextTick(() => {
        this.cancel();
        this.$nextTick(() => this.create());
      });
    },
    closed(a) {
      console.log('closed: websocket connect is close.');
      this.$emit('close', a);
      this.$nextTick(() => {
        this.cancel();
        this.$nextTick(() => this.create());
      });
    },
    cancel() {
      this.$emit('cancel', this.status);
      this.$nextTick(() => {
        clearInterval(this.interval);
        this.$nextTick(() => {
          this.interval = null;
          this.session = null;
          this.status = false;
        });
      });
    },
  },
  render() {
    return (
      <div class="a-web-socket">{this.$slots.default}</div>
    );
  }
}